import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppRouter from "./components/AppRouter/AppRouter";
import HomeRu from "./pages/HomeRu/HomeRu";
import Home from "./pages/Home/Home";
import { CONTACTS_ROUTE, CONTACTS_ROUTE_RU } from "./utils/routes";
import ContactsPage from "./pages/ContactsPage/ContactsPage";
import ContactsPageRu from "./pages/ContactsPageRu/ContactsPageRu";
import { ProductPagesRu } from "./utils/ProductPages/ProductPagesRu";
import ProductPage from "./pages/ProductPage/ProductPage";
import { ProductPagesUa } from "./utils/ProductPages/ProductPagesUa";
import { CatalogPages } from "./utils/CatalogPages/CatalogPages";
import CatalogPage from "./pages/CatalogPage/CatalogPage";
import BlogHubPage from "./pages/BlogHubPage/BlogHubPage";
import RecipesHubPage from "./pages/RecipesHubPage/RecipesHubPage";
import { RecipesHubArr } from "./utils/Recipes/RecipesHubArr";
import { RecipesHubArrRu } from "./utils/Recipes/RecipesHubArrRu";
import { RecipesPagesArr } from "./utils/Recipes/RecipesPagesArr";
import RecipePage from "./pages/RecipePage/RecipePage";
import { RecipesPagesArrRu } from "./utils/Recipes/RecipesPagesArrRu";
import { BlogHubArr } from "./utils/Blog/BlogHubArr";
import { BlogHubArrRu } from "./utils/Blog/BlogHubArrRu";
import { BlogPagesArr } from "./utils/Blog/BlogPagesArr";
import BlogPage from "./pages/BlogPage/BlogPage";
import { BlogPagesArrRu } from "./utils/Blog/BlogPagesArrRu";
import AboutProductionPage from "./pages/AboutProductionPage/AboutProductionPage";
import AboutProductionPageRu from "./pages/AboutProductionPageRu/AboutProductionPageRu";
import AboutPastoralPage from "./pages/AboutPastoralPage/AboutPastoralPage";
import AboutPastoralPageRu from "./pages/AboutPastoralPageRu/AboutPastoralPageRu";
import AboutMumulyaPage from "./pages/AboutMumulyaPage/AboutMumulyaPage";
import AboutMumulyaPageRu from "./pages/AboutMumulyaPageRu/AboutMumulyaPageRu";
import CooperationPage from "./pages/CooperationPage/CooperationPage";
import CooperationPageRu from "./pages/CooperationPageRu/CooperationPageRu";
import { CatalogPagesRu } from "./utils/CatalogPages/CatalogPagesRu";


function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
        <Route path="/" element={<AppRouter />}>
          <Route index element = {<Home />} />
          <Route path="/ru" element = {<HomeRu />} />
          <Route path={"/about-us/production/"} element = {<AboutProductionPage />} />
          <Route path={"/ru/about-us/production/"} element = {<AboutProductionPageRu />} />
          <Route path={"/about-us/pastoral/"} element = {<AboutPastoralPage />} />
          <Route path={"/ru/about-us/pastoral/"} element = {<AboutPastoralPageRu />} />
          <Route path={"/about-us/mumulya/"} element = {<AboutMumulyaPage />} />
          <Route path={"/ru/about-us/mumulya/"} element = {<AboutMumulyaPageRu />} />
          <Route path={CONTACTS_ROUTE} element = {<ContactsPage />} />
          <Route path={CONTACTS_ROUTE_RU} element = {<ContactsPageRu />} />
          <Route path={"/blog/"} element = {<BlogHubPage hubObj={BlogHubArr} />} />
          <Route path={"/ru/blog/"} element = {<BlogHubPage hubObj={BlogHubArrRu} />} />
          <Route path={"/recipes/"} element = {<RecipesHubPage hubObj={RecipesHubArr} />} />
          <Route path={"/ru/recipes/"} element = {<RecipesHubPage hubObj={RecipesHubArrRu} />} />
          <Route path={"/cooperation/"} element = {<CooperationPage />} />
          <Route path={"/ru/cooperation/"} element = {<CooperationPageRu />} />
          {
            CatalogPages.map((page, idx) => {
              return (
                <Route key={idx} path={page.path} element={<CatalogPage path={page.path} metaTitle={page.metaTitle} metaDescription={page.metaDescription} coverTitle={page.coverTitle} coverImage={page.coverImage} coverImageMobile={page.coverImageMobile} aboutTitle={page.aboutTitle} aboutTexts={page.aboutTexts} aboutImage={page.aboutImage} brands={page.brands} />} />
              )
            })
          }
          {
            CatalogPagesRu.map((page, idx) => {
              return (
                <Route key={idx} path={page.path} element={<CatalogPage path={page.path} metaTitle={page.metaTitle} metaDescription={page.metaDescription} coverTitle={page.coverTitle} coverImage={page.coverImage} coverImageMobile={page.coverImageMobile} aboutTitle={page.aboutTitle} aboutTexts={page.aboutTexts} aboutImage={page.aboutImage} brands={page.brands} />} />
              )
            })
          }
          {
            ProductPagesUa.map((page, idx) => {
              return (
                <Route key={idx} path={page.path} element={<ProductPage metaTitle={page.metaTitle} metaDescription={page.metaDescription} coverImageMobile={page.coverImageMobile} coverImage={page.coverImage} coverTitle={page.coverTitle} aboutImage={page.aboutImage} aboutTitle={page.aboutTitle} aboutStats={page.aboutStats} aboutLink={page.aboutLink} aboutInformation={page.aboutInformation} categoryInfo={page.categoryInfo} category={page.category} path={page.path} productPageLang={ProductPagesUa} 
                />} />
              )
            })
          }
          {
            ProductPagesRu.map((page, idx) => {
              return (
                <Route key={idx} path={page.path} element={<ProductPage metaTitle={page.metaTitle} metaDescription={page.metaDescription} coverImage={page.coverImage} coverImageMobile={page.coverImageMobile} coverTitle={page.coverTitle} aboutImage={page.aboutImage} aboutTitle={page.aboutTitle} aboutStats={page.aboutStats} aboutLink={page.aboutLink} aboutInformation={page.aboutInformation} categoryInfo={page.categoryInfo} category={page.category} path={page.path} productPageLang={ProductPagesRu}/>} />
              )
            })
          }
          {
            RecipesPagesArr.map((page, idx) => {
              return (
                <Route key={idx} path={page.path} element={<RecipePage recipe={page} />} />
              )
            })
          }
          {
            RecipesPagesArrRu.map((page, idx) => {
              return (
                <Route key={idx} path={page.path} element={<RecipePage recipe={page} />} />
              )
            })
          }
          {
            BlogPagesArr.map((page, idx) => {
              return (
                <Route key={idx} path={page.path} element={<BlogPage article={page} />} />
              )
            })
          }
          {
            BlogPagesArrRu.map((page, idx) => {
              return (
                <Route key={idx} path={page.path} element={<BlogPage article={page} />} />
              )
            })
          }
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
